import { toast } from 'sonner';
import { useMutation } from '@apollo/client/react';

import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { ActivationNotification } from 'src/containers/SoftwareEscrow/Technical';
import { SoftwareEscrowUpdateDocument } from 'src/graphql/actions/softwareEscrow/softwareEscrowUpdate.mutation';
import { ClientError, getApiError } from 'src/utils/errors';

const ActivationNotificationsPage = () => {
  const {
    softwareEscrow: { id: softwareEscrowId, activationNotification },
  } = useSoftwareEscrow();
  const [updateDepositSettings] = useMutation(SoftwareEscrowUpdateDocument);

  const onActivationNotificationChange = async (activationNotification: boolean | null) => {
    if (activationNotification === null) return;

    try {
      const { data } = await updateDepositSettings({
        variables: {
          softwareEscrowId,
          softwareEscrowParams: {
            activationNotification,
          },
        },
      });

      if (data?.softwareEscrowUpdate?.success) {
        toast.success('Saved!');
      } else {
        throw new ClientError(data?.softwareEscrowUpdate?.errors?.[0]);
      }
    } catch (e: unknown) {
      getApiError(e, toast.error);
    }
  };

  return (
    <SoftwareOnboardingMain
      subtitle="Technical information:"
      title="Activation notifications for beneficiaries"
      description="Control whether the beneficiary gets notified when this escrow becomes active. No other notifications will automatically be shared with the beneficiary of a bipartite escrow."
      noteText="Note: You can edit this before activating the escrow under Settings → Technical Information."
    >
      <div className="max-w-260 w-full mx-auto">
        <ActivationNotification
          onActivationNotificationChange={onActivationNotificationChange}
          activationNotification={activationNotification}
        />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default ActivationNotificationsPage;
